import { makeAutoObservable, runInAction } from "mobx";
import { getEmployeeSalary } from "../services/payroll/getPayroll";
import { getEmployeeById } from "../services/auth/getEmployee";
import { getEmployeeSalaryById } from "../services/salary/getSalary";


export default class SalaryStore {
  salaryList = null;
  loading = false;
  error = null;

  isAdjustModal = false;

  personalInfoFormData = {};

  salaryAdjustmentFormData = {};

  constructor() {
    makeAutoObservable(this);
  }

  fetchEmployeeSalary = async () => {
    this.loading = true;
    this.error = null;

    try {
      const response = await getEmployeeSalary();
      runInAction(() => {
        this.salaryList = response.employeeSalaries;
        this.loading = false;
      });
    } catch (err) {
      runInAction(() => {
        this.error = err.message || "Failed to fetch payroll data";
        this.loading = false;
      });
    }
  };

  setIsAdjustModal = (bool) => {
    runInAction(()=>{
      this.isAdjustModal = bool;
    })
  }

  setGetSalaryEmployeeId = async (values) => {
    runInAction(async () => {
      this.employeeId = values;
      const response = await getEmployeeById(values);
      //console.log(response);
      this.personalInfoFormData = { ...this.personalInfoFormData, ...response };
    });
  };

  setSalaryAdjustmentFormData = (values) => {
    runInAction(()=>{
      runInAction(async () => {
        this.employeeId = values;
        const response = await getEmployeeSalaryById(values);
        this.salaryAdjustmentFormData = { ...this.salaryAdjustmentFormData, ...response };
      });
      
    })
  }
}
